<template>
    <ui-tooltip-function v-bind="binds.tips" ref="tips">
        <!-- * 密码子表 -->
        <module-codon-contrast ref="comparison" />

        <!-- * 内容区域 -->
        <ui-simplebar :class="css.simplebar" ref="simplebar" :height="size" trigger="Hover" @scroll="methods.scroll">
            <!-- * 信息弹窗 -->
            <module-info
                ref="info"
                :mode="mode"
                :specie="specie"
                @next="methods.next"
                @codon="comparison?.open(info?.$el)"
                @mutations="methods.mutations" />
            <div class="container">
                <svg :class="css.canvas" ref="container"></svg>
            </div>
        </ui-simplebar>

        <!-- * 悬浮窗口 -->
        <template #content>
            <div :class="[css.content, css.area]" v-on="ons.body" ref="tooltip" v-if="area?.type == 'area'">
                <div :class="css.title" class="font-variable font-bold color-1">{{ area.name || "--" }}</div>
                <div :class="css.modules">
                    <div :class="css.module">
                        <div :class="css.name">{{ useColon($t("Position")) }}</div>
                        <div :class="css.value" class="color-1 font-bold">
                            {{ area.data?.start && area.data?.end ? `${area.data.start}-${area.data.end}` : "--" }}
                        </div>
                    </div>
                    <div :class="css.module">
                        <div :class="css.name">{{ useColon($t("Length")) }}</div>
                        <div :class="css.value" class="color-1 font-bold">
                            {{ area.data?.size || "--" }}
                        </div>
                    </div>
                </div>
                <div :class="css.notes">* {{ $t("RelevantSequences") }}</div>
            </div>
        </template>
    </ui-tooltip-function>
</template>

<script lang="ts" setup>
//* 组件库
import { UiTooltipFunction, UiSimplebar } from "various-ui";
//* 组件属性
import { useComposable } from "./src/composable";
import { DrawEmitsOption } from "./src/types";
//* 私有组件
import ModuleCodonContrast from "../codon-contrast/index.vue";
import ModuleInfo from "./components/info/index.vue";

//* 样式
import css from "./index.module.less";

//* 组件属性注册
const emits = defineEmits(DrawEmitsOption);
defineProps({
    specie: { type: Number },
});

//* 组合函数
const { ons, refs, nodes, binds, methods } = useComposable(emits);
const { move, exons, render, update, sequence, cds, radius } = methods;
const { tips, container, tooltip, comparison, info, simplebar } = nodes;
const { area, mode, size } = refs;

//* 组件属性导出
defineExpose({ cds, move, exons, render, update, sequence, radius });
</script>
